/**
 * Generic queue data structure.
 *
 * This uses a delayed shift back algorithm to minimize the amount of times
 * the array is updated.
 */
export class Queue {
    constructor(maxSize = 1000) {
        this.container = [];
        this.maxSize = maxSize;
        this.start = 0;
    }
    /**
     * Shift back the array to the start.
     */
    shiftBack() {
        for (let i = this.start; i < this.container.length; i += 1) {
            this.container[i - this.start] = this.container[i];
        }
        this.container.length -= this.start;
        this.start = 0;
    }
    /**
     * Push an item to the end of the queue.
     *
     * @param data
     */
    enqueue(data) {
        this.container.push(data);
    }
    /**
     * Pop an item from the start of the queue.
     *
     * @returns
     */
    dequeue() {
        if (this.start === this.container.length) {
            return undefined;
        }
        const data = this.container[this.start];
        this.start += 1;
        if (this.start > this.maxSize) {
            this.shiftBack();
        }
        return data;
    }
    /**
     * Get the length of the queue.
     *
     * @returns
     */
    get length() {
        return this.container.length - this.start;
    }
}
